import Kampagnen from '@/models/kampagnen';

let loadingPromise;

export const kampagnenLoader = {
  methods: {
    loadKampagnen() {
      if (!loadingPromise) {
        loadingPromise = Kampagnen.api().get('/api/kampagnen', {
          dataTransformer: ({ data }) => {
            data.forEach(kampagne => {
              kampagne.geaendertam = new Date(kampagne.geaendertam).getTime();
            });
            return data;
          }
        });
      }
      return loadingPromise;
    }
  }
};
